export class Resources {
    static companyName = "The Window Outfitters";
    static phoneNumber = "(647) 862-2009";
    static socialInstagram = "https://www.instagram.com/windowoutfitters/";
}


// WEBPACK FOOTER //
// ./src/resources.js